
<ng-template [ngIf]="incassoForm ">
<div class="col-sm-12 coldx">
	<h4 *ngIf="title">{{title}}</h4>
	
	<ng-template [ngIf]="soggettiPagatoriOptions && soggettiPagatoriOptions.length == 0 && msgNoBeneficiari">
	<p>{{msgNoBeneficiari}}</p>
	</ng-template>
	
	<div *ngIf="soggettiPagatoriOptions.length>0" class="tab-content">
		<form [formGroup]="incassoForm" (ngSubmit)="update();">
			<div class="row">
				<div datePickerInput [control]="incassoForm.controls['dataIncasso']"
					class="col-sm-4" [labelInput]="'Data incasso'"
					formControlName="dataIncasso" [(ngModel)]="request.dataIncasso"
					[mandatory]="true"></div>

				<div
					comboModInput [control]="incassoForm.controls['soggettoPagatore']"
					class="col-sm-4" [labelInput]="'Soggetto pagatore'"
					[mandatory]="true" formControlName="soggettoPagatore"
					[labelOption]="'parte.nominativo'"
					[optionsCombo] ="soggettiPagatoriOptions"
					[objectReference]="request.soggettoPagatore"
					(onReturn)="request.soggettoPagatore = $event"
					[ngModel]="request.soggettoPagatore"></div>

				<div textInput [control]="incassoForm.controls['causale']"
					class="col-sm-4" [mandatory]="true" [labelInput]="'Causale'"
					formControlName="causale" [(ngModel)]="request.causale"></div>
			</div>
			<div class="row">
				<!--<div comboModInput class="col-sm-4" [labelInput]="'Competenze incasso'"
					formControlName="refAreaCompetente"
					[labelOption]="'gruppoVisibilita.nomeGruppo'"
					[objectReference]="request.areaCompetente"
					(onReturn)="request.areaCompetente = $event"
					[ngModel]="request.areaCompetente"
					[location]="'gruppiVisibilita'"
					[optionsCombo] ="fascicolo.registroFascicolo.gruppiVisibilita" ></div>-->

				<div comboModInput class="col-sm-6" [labelInput]="'Tipo incasso'"
					formControlName="tipoIncasso"
					[objectReference]="request.tipoIncasso"
					(onReturn)="request.tipoIncasso = $event"
					[optionsCombo] ="tipiIncassoOptions" ></div>

				<div comboModInput class="col-sm-6"
					[labelInput]="'Modalit&agrave; incasso'"
					formControlName="modalitaIncasso"
					[objectReference]="request.modalitaIncasso"
					(onReturn)="request.modalitaIncasso = $event"
					[optionsCombo] ="modalitaIncassoOptions"></div>

			</div>
			<div *ngFor="let totale of [( getSum( request.importo ? request.importo : '0',
												  request.interessi ? request.interessi : '0',
												  request.spese ? request.spese : '0',
												  request.compensoAvvocati ? request.compensoAvvocati : '0')  )]">
			<div class="container_conteggi">
				<div textInputCurrency [labelInput]="'Petitum'" formControlName="importo"
					[(ngModel)]="request.importo"></div>
				<div textInputCurrency [labelInput]="'Interessi'" formControlName="interessi"
					[(ngModel)]="request.interessi"></div>
				<div textInputCurrency [labelInput]="'Spese'" formControlName="spese"
					[(ngModel)]="request.spese"></div>
				<div textInputCurrency [labelInput]="'Compenso avvocati'" formControlName="compensoAvvocati"
					[(ngModel)]="request.compensoAvvocati"></div>
				
					<p class="col-xs-12 col-sm-offset-7 col-sm-2 alignright">
						<label for="tot-inc-frm-lbl">Totale</label>
					</p>
					<p class="col-xs-12 col-sm-3">
						<input id="tot-inc-frm-lbl" class="alignright totale form-control" disabled="" value="{{ totale | euro}} &euro;" type="text">
					</p>
				
			</div>
			<div class="row">
				<div textAreaInput class="col-xs-12 col-sm-12" [labelInput]="'Note'"
					formControlName="note" [(ngModel)]="request.note"></div>
			</div>
			<div class="row">
				<p class="mandatory col-sm-12">
					<em>* Campi obbligatori</em>
				</p>
			</div>
			<div class="row">
				<p class="col-sm-3 col-xs-6">
					<button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset</button>
				</p>
				<p submitButton [disabled]="!incassoForm.valid || (totale == '0,00')"
					class="col-sm-3 col-xs-6 col-sm-offset-6"
					[labelButton]="'Salva'"></p>
			</div>
			</div>
		</form>
	</div>
</div>
</ng-template>